(() => {
  const main = document.querySelector('#MainContent[data-template="product"]');
  const strings = window.maxSportsCROStrings;
  if (!main || !strings || !strings.tensionHelp) return;
  let frame = 0;
  const install = () => {
    frame = 0;
    main.querySelectorAll('.gpo-element').forEach((field) => {
      const inputs = [...field.querySelectorAll('select,input')].filter((input) => /string tension/i.test(input.name || input.getAttribute('aria-label') || ''));
      if (!inputs.length || field.querySelector('.maxsports-tension-help')) return;
      const help = document.createElement('div');
      help.className = 'maxsports-tension-help caption';
      help.id = 'maxsports-tension-help-' + [...main.querySelectorAll('.gpo-element')].indexOf(field);
      const text = document.createElement('p');
      text.textContent = strings.tensionHelp;
      help.appendChild(text);
      if (strings.stringingUrl) {
        const link = document.createElement('a');
        link.href = strings.stringingUrl;
        link.textContent = strings.stringingDetails;
        help.appendChild(link);
      }
      field.appendChild(help);
      inputs.forEach((input) => {
        const ids = new Set((input.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
        ids.add(help.id);
        input.setAttribute('aria-describedby', [...ids].join(' '));
      });
    });
  };
  const observer = new MutationObserver((records) => {
    if (frame || !records.some((record) => [...record.addedNodes].some((node) => node.nodeType === 1 && (node.matches('.gpo-app,.gpo-element,select,input') || node.querySelector('.gpo-app,.gpo-element'))))) return;
    frame = requestAnimationFrame(install);
  });
  install();
  observer.observe(main, {childList: true, subtree: true});
})();
